module.exports = __webpack_public_path__ + "media/images/athletes/3558-16334602188a008e3d6c8925b0483f1e.png";